export default "__VITE_ASSET__0XDmHuai__"